// Version : 0.0.3
// Author : VIGNESH
// LastEdit: VIGNESH
// MODFIED DATE : 07-12-2025
// LAST MOFIFIED: ADDED COMMENTS AND REMOVED UNWANTED REDUX

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START GOLD LOAN INTEREST REMAINDER REPORT DETAILS  ******************** */
export const requestReportDetailsFetch = (fetchData: any) => {
	const data = {
		FetchGoldLoanInterestReminderToken: fetchData,
	};
	const url = `${API_URL}PostGoldInterestReminderReport`;
	return makeApiCall(url, data);
};
/** *********************  END GOLD LOAN INTEREST REMAINDER REPORT DETAILS  ******************** */
